import React from 'react';

const Discounts = (props) => {
  return (
    <div className="mt-2 discounts_container">
      { props.data.discounts.length>0 && props.data.discounts.map((data, i) => 
        <div key = {"discount_"+props.data.key+"_"+i} className="discount_cell d-flex align-items-center my-1 me-2 discount text-sm inline-flex items-center" title="discount">
          <svg width="24" height="24" viewBox="0 0 24 24" aria-hidden="true" focusable="false" role="presentation" className="icon icon--discount d-inline">
            <g fill="none" fillRule="evenodd"><g transform="translate(8.855 3)"><path d="m6.677.544 5.01 4.24a1 1 0 0 1 .354.764V17a1 1 0 0 1-1 1H1.02a1 1 0 0 1-1-1V5.497a1 1 0 0 1 .358-.767L5.389.54a1 1 0 0 1 1.288.004z" stroke="currentColor" strokeWidth="1.5"></path><path stroke="currentColor" strokeWidth="1.5" strokeinecap="square" d="M.5 14.024h11"></path><circle fill="currentColor" cx="6" cy="5.052" r="1"></circle></g><path d="M9.988 21H4.125a1 1 0 0 1-1-1V8.497a1 1 0 0 1 .359-.767l5.01-4.19a1 1 0 0 1 1.288.004l2.167 1.834" stroke="currentColor" strokeWidth="1.5"></path><path stroke="currentColor" strokeWidth="1.5" strokeLinecap="square" d="M3.605 17.024h5.25"></path></g></svg> 
          {data.title} (-${data.amount/100})
        </div>
      )}
    </div>
  );
};

export default Discounts;
